"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var types_1 = require("types");
var actions = require("@caddigital/sok-reducers/lib/actions/modelspace/customer");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
require("./modelspace.scss");
var components_1 = require("components");
var mapStateToProps = function (state) {
    return {
        modelspace: state.modelspace.customer
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    fetch: function (customerId) { return dispatch(actions.fetchRequest(customerId)); },
    add: function (customerId, configuration) {
        return dispatch(actions.addRequest(customerId, configuration));
    },
    updateField: function (key, value) {
        return dispatch(actions.updateField(key, value));
    },
    removeConfiguration: function (customerId, configuration) { return dispatch(actions.removeRequest(customerId, configuration)); },
    clear: function () { return dispatch(actions.clear()); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
//#region Types
var statePropsExtractable = (0, types_1.extractReturnType)(exports.mapStateToProps);
var dispatchPropsExtractable = (0, types_1.extractReturnType)(exports.mapDispatchToProps);
//#endregion
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        if (this.props.isOpen) {
            this.props.fetch(this.props.customerId);
        }
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.isOpen !== prevProps.isOpen) {
            if (this.props.isOpen) {
                this.props.fetch(this.props.customerId);
            }
            else {
                this.props.clear();
            }
        }
    },
    shouldComponentUpdate: function (nextProps) {
        if (nextProps.isOpen || this.props.isOpen !== nextProps.isOpen) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
var getError = function (index, error) {
    if (!error || !error[index] || (error[index] && error[index].length === 0)) {
        return React.createElement("span", { key: "validation-".concat(index), className: 'validation-error' });
    }
    return (React.createElement("span", { key: "validation-".concat(index), className: 'validation-error' }, error[index][0]));
};
exports.default = enhance(function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(sok_ui_1.Modal, { isOpen: props.isOpen, className: 'customer-wizard-modal-modelspace' },
            React.createElement(sok_ui_1.Header, { onClose: function () { return props.toggleModal(false); } }, "Modelspace"),
            React.createElement(sok_ui_1.Container, null,
                React.createElement(sok_ui_1.RequestStatusBox, { status: props.modelspace.addStatus },
                    (0, translation_1.getLocalization)("modelspace/status/saving"),
                    (0, translation_1.getLocalization)("modelspace/status/saved"),
                    (0, translation_1.getLocalization)("modelspace/status/failed")),
                React.createElement(sok_ui_1.RequestStatusBox, { status: props.modelspace.removeStatus },
                    (0, translation_1.getLocalization)("modelspace/status/removing"),
                    (0, translation_1.getLocalization)("modelspace/status/removed"),
                    (0, translation_1.getLocalization)("modelspace/status/failed")),
                React.createElement("div", { className: 'add-configuration' },
                    React.createElement("div", { className: 'configuration-name' },
                        React.createElement("label", { htmlFor: 'configuration-name' },
                            (0, translation_1.getLocalization)('customer/name'),
                            ":"),
                        React.createElement(sok_ui_1.TextInput, { id: 'configuration-name', disabled: true, value: props.customerName || '' })),
                    React.createElement("div", { className: 'configuration-id' },
                        React.createElement("label", { htmlFor: 'configuration-id' },
                            (0, translation_1.getLocalization)('modelspace/configurationId'),
                            ":"),
                        React.createElement(sok_ui_1.TextInput, { id: 'configuration-id', value: props.modelspace.configuration.configurationId, onChange: function (_a) {
                                var value = _a.target.value;
                                return props.updateField('configurationId', value);
                            } }),
                        getError("configurationId", props.modelspace.validationError)),
                    React.createElement("div", { className: 'customer-id' },
                        React.createElement("label", { htmlFor: 'customer-id' },
                            (0, translation_1.getLocalization)('modelspace/customerId'),
                            ":"),
                        React.createElement(sok_ui_1.TextInput, { id: 'customer-id', value: props.modelspace.configuration.customerId, onChange: function (_a) {
                                var value = _a.target.value;
                                return props.updateField('customerId', value);
                            } }),
                        getError("customerId", props.modelspace.validationError)),
                    React.createElement("div", { className: 'add' },
                        React.createElement(sok_ui_1.Button, { color: 'green', size: 'medium', disabled: props.modelspace.fetchStatus !== 'FETCHED' ||
                                props.modelspace.addStatus === 'FETCHING', onClick: function () {
                                return props.add(props.customerId, props.modelspace.configuration);
                            } }, (0, translation_1.getLocalization)('userfront/button/add')))),
                props.modelspace.fetchStatus === 'FAILED' && (React.createElement("div", null,
                    React.createElement(GenericErrorMessage_1.default, { className: 'small' },
                        React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () { return props.fetch(props.customerId); } })))),
                props.modelspace.fetchStatus === 'FETCHING' && (React.createElement("div", { className: 'center' },
                    React.createElement(sok_ui_1.LoadingSpinner, null))),
                props.modelspace.fetchStatus === 'FETCHED' && (React.createElement("div", { className: 'configuration-list' },
                    React.createElement("div", { className: 'header' },
                        React.createElement("div", null, (0, translation_1.getLocalization)('modelspace/configurationId')),
                        React.createElement("div", null, (0, translation_1.getLocalization)('modelspace/customerId')),
                        React.createElement("div", { className: 'remove' })),
                    props.modelspace.configurations.map(function (x) { return (React.createElement("div", { className: 'configuration' },
                        React.createElement("div", null, x.configurationId),
                        React.createElement("div", null, x.customerId),
                        React.createElement("div", { className: 'remove' },
                            React.createElement(components_1.TableRowIcon, { icon: 'fa-times-circle', onClick: function () {
                                    return props.removeConfiguration(props.customerId, x);
                                } })))); })))),
            React.createElement(sok_ui_1.Footer, null,
                React.createElement(sok_ui_1.Button, { disabled: props.modelspace.fetchStatus === 'FETCHING' ||
                        props.modelspace.addStatus === 'FETCHING' ||
                        props.modelspace.removeStatus === 'FETCHING', text: (0, translation_1.getLocalization)('buttons/close'), color: 'dark-gray', onClick: function () { return props.toggleModal(false); } })))));
});
